import { render, staticRenderFns } from "./PropertyStub.vue?vue&type=template&id=b5e74178&"
import script from "./PropertyStub.vue?vue&type=script&lang=ts&"
export * from "./PropertyStub.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports